<template>
  <div class="content-wraper">
    <div class="title">
      <van-nav-bar
          title="预约"
          left-arrow
          @click-left="$router.back()"
      />
    </div>
    <!--  -->
    <div class="content">
      
      <van-search v-model="searchKey" shape="round" placeholder="请输入搜索关键词" @search="onSearch"/>
      <p class="tip-text" >说明：一个线下实训只可预约一个实训课程</p>
      
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text=""
        :immediate-check="false"
        ref="list"
        @load="onLoad"
        v-show="subscribList.length"
      >
        <ul class="sub-list">
          <li class="sub-item" v-for="(item, index) in subscribList" :key="index">
            <div class="title-text two-line ">
              {{item.trainingName}}
            </div>
            <div class="address clearfix" >
              <div class="label">
                实训基地:
              </div>
              <div class="address-detail two-line">
                {{item.trainingAddressName}}
              </div>
            </div>
            <div class="address  clearfix">
              <div class="label">
                地<span style="color:transparent">实训</span>址:
              </div>
              <div class="address-detail two-line">
                {{item.trainingAddress}}
              </div>
            </div>
            <div class="button" >
              <div class="order-button" :class="item.isReserved? 'active':''"  @click="subscribe(item)" >{{item.isReserved?'取消预约' : '预约'}}</div>
            </div>
          </li>
        </ul>
      </van-list>
      <div class="no-search" v-show="!subscribList.length">
          <img src="../../../assets/images/learning/nolist.png"/>
          <div>暂无数据</div>
      </div>
    </div>

    <van-dialog v-model="showTip" :showConfirmButton="false">
      <div class="tooltip">
        <img class="bg-img" src="../../../assets/images/learning/tooltip.png"/>
        <span class="warn">提示</span>
        <span class="tip-text">{{!isSame?'您已存在预约记录，是否更换预约？':'确定取消预约吗？'}}</span>
        <div class="buttons">
          <div class="cancle button" @click="cancle">取消</div>
          <div class="confirm button" @click="confirm">确定</div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  name: 'subscribeList',
  data() {
    return {
      searchKey: '',
      showTip: false,
      subscribList: [],
      isSame: false,
      loading: false,
      finished: false,
      pageNum: 1,
      isSearch: false,
      noSearchList: false
    }
  },
  
  created() {
    this.taskId = this.$route.query.taskId
  },
  mounted() {
     this.getUserTaskTrainingList()
  },
  methods: {
    confirm() {
      if(this.isSame) { // 取消预约
        this.cancelTaskTraining()
      } else {
        this.replaceTaskTraining()
      }
    },
    cancle() {
      this.showTip = false
    },
    async subscribe(item) {
      
      // this.readyExist()
      this.clickItem = {...item}
      let result = await this.isUserTaskTrainingReserved()
      item.isReserved ? this.isSame = true : this.isSame = false 
      if(result) { // true, 已经预约
        this.showTip = true
      } else {
        this.reserveTaskTraining(item)
      }
     
    },
    // 搜索
    onSearch() {
      this.isSearch = true
      this.getUserTaskTrainingList()
    },
    onLoad() {
      this.pageNum = this.pageNum*1 + 1
      this.isLoad = true
      this.getUserTaskTrainingList()
    },
    // 获取用户指定培训任务可选择线下实训列表及预约状态
    async getUserTaskTrainingList() {
      const params = {
        searchKey: this.searchKey,
        taskId: this.taskId,
        pageNum: this.isLoad?this.pageNum : 1,
        pageSize: 20
      }
      let result = await this.$api.learning.getUserTaskTrainingList(params)
      if(result.success) {
        if(this.isLoad) { // 
          this.subscribList = [...this.subscribList, ...result.data.list]  
          this.pageNum = result.data.pageNum
        } else {
          if(this.isSearch) {
             result.data.list? this.noSearchList = false : this.noSearchList = true
          }
          this.subscribList = result.data.list || []
          this.pageNum = result.data.pageNum
         
        }
        this.isLoad = false
        // this.isUserTaskTrainingReserved()
        this.finished = !result.data.hasNextPage
        this.loading = false 
        this.isSearch = false
      }
    },
     // 判断用户指定培训任务是否已经预约线下实训项目
    async isUserTaskTrainingReserved() {
      const params = {
        taskId: this.taskId
      }
      let result = await this.$api.learning.isUserTaskTrainingReserved(params)
      if(result.success) {
        this.isReserved = result.data
      }
      return result.data
    },
    // 重新预约新的线下实训项目并取消旧的预约
    async replaceTaskTraining() {
      const params = {
        taskId: this.taskId,
        trainingCourseId: this.clickItem.id
      }
      let result = await this.$api.learning.replaceTaskTraining(params)
      if(result.success) {
        // this.isReserved = result.data
        this.subscribList = []
        this.getUserTaskTrainingList()
        
        this.$toast({
            message: this.isSame?'取消成功':'预约成功',
            position: 'middle',
        });  
      }
      this.showTip = false
       this.$refs.list.check((pos) => {
          console.log(pos, '===')
        })
    },
    //  预约指定线下实训项目
    async reserveTaskTraining(item) { 
      if(item.isReserved) { // 1⃣️预约
        this.isSame = true
        // this.showTip = true 
        this.cancelTaskTraining()
      } else {
        const params = {
          taskId: this.taskId,
          trainingCourseId: item.id
        }
        let result = await this.$api.learning.reserveTaskTraining(params)
        if(result.success) {
          this.subscribList = []

          this.getUserTaskTrainingList()

          this.$toast({
              message: '预约成功',
              position: 'middle',
          });  
        }
        this.showTip = false
      }
      
    },
    // 取消预约指定线下实训项目
    async cancelTaskTraining() {
       const params = {
        taskId: this.taskId,
        trainingCourseId: this.clickItem.id
      }
      let result = await this.$api.learning.cancelTaskTraining(params)
      if(result.success) {
        // this.isReserved = result.data
        this.subscribList = []

        this.getUserTaskTrainingList()
        this.$toast({
            message: this.isSame?'取消成功':'预约成功',
            position: 'middle',
        }); 
        this.$refs.list.check((pos) => {
                    console.log(pos, '===')

        })
      }
      this.showTip = false

    }



  }
}
</script>
<style lang="stylus">
 .content-wraper .title
    .van-hairline--bottom::after
      border-color #fff
  .content-wraper .content 
    .van-search
      padding-top 14px
</style>
<style lang="stylus" scope>
.content-wraper
  width 100%
  // position relative
  height 100%
  background-color  #F5F6FA
  font-family: PingFangSC-Regular, PingFang SC
  .tooltip
    display flex
    flex-direction column
    align-items center
    justify-content center 
    padding 64px 0 48px
    .bg-img 
      width 228px
      height  164px
    .warn
      font-size: 40px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #202124;
      margin-top 15px
    .tip-text 
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #202124;
      margin-top 32px
    .buttons
      display flex
      justify-content space-between
      margin-top 48px
      padding 0 48px
      .button
        border-radius 44px
        font-size 32px
        width 236px
        height 80px
        border 1px solid rgba(0,0,0,0)
        line-height 80px
      .cancle 
        background-color #fff 
        color #3860FF
        border-color #3860FF
        margin-right 22px
      .confirm 
        background-color #3860FF
        color #fff

  .title 
    width 100%
    position fixed
    left 0
    top 0
    z-index 50
   
  .content
    padding-top 80px
    background-color  #F5F6FA
    padding-bottom 30px
    .no-search
      margin-top 26%
      margin-bottom 300px
      display flex 
      flex-direction column
      justify-content center 
      align-items center
      img 
        width 300px
        height 191px
      div
        color: #999999;
        font-size: 0.906rem;
        font-weight: 400;
        margin-top: 0.693rem;
        font-family: PingFangSC-Regular, PingFang SC;
    .tip-text 
      color #4567FF
      margin 30px 0 0 0
      box-sizing border-box
      font-size 24px
      padding-left 60px
    .sub-list 
      width 100%
      .sub-item
        box-sizing border-box
        margin 30px 
        background-color #fff
        padding 0px 0 32px
        border-radius 16px
        // width 690px
        color #333
        .two-line 
          overflow hidden; 
          text-overflow ellipsis;
          display -webkit-box; 
          -webkit-box-orient vertical;
          -webkit-line-clamp 2; 
        .title-text
          // font-size 32px
          word-break break-all
          // font-weight: 500;
          // line-height 64px
          width: 626px;
          // height: 90px;
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 700;
          color: #333333;
          line-height: 42px
          padding 24px 32px 24px
          border-bottom 1px solid  #EAEAEA
        .address
          
          // display flex 
          // &:nth-child(1)
          //   margin-top 61px
          padding 0 32px
          &:nth-child(2)
            margin-bottom 30px
            margin-top 30px
          .label 
            width 105px
            float left 
            font-size 24px
            line-height 44px
            // height: 70px;
            text-align: justify;
            vertical-align: top;
            display inline-block
            // text-align: justify;
            // text-align-last: justify
            padding-right 15px
            line-height 36px
            color #999
          .address-detail
            // width 506px
            float right
            word-break break-all
            // font-size 24px
            width: 506px;
            // height: 70px;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            // line-height: 36px;
            line-height 36px

        .button 
          display flex
          justify-content flex-end
          margin-top 20px
          padding 0 32px
          .order-button
            width: 156px;
            height: 72px;
            border-radius: 36px;
            border: 1px solid #3760FF;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            line-height: 72px;
            text-align: center;
            color: #3760FF
            font-weight: 700;
            &.active 
               color: #666 
               border-color rgba(102, 102, 102, 0.8);
            

      
                            
                        
          
         

</style>